/* Highest level tabs */
export const TAB_MISSING	= 0
export const TAB_TIME		= 1
export const TAB_LOCATION	= 2
export const TAB_SPEC		= 3
export const TAB_OTHER		= 4
export const TAB_OBS		= 5
export const TAB_COMPARE	= 6

/* Time tab */
export const TAB_YEAR		= 10
export const TAB_MONTH		= 11
export const TAB_MONTH_MATRIX	= 12
export const TAB_DATE		= 13
export const TAB_MONTH_SUM	= 14
export const TAB_DAY		= 15
export const TAB_WINTER		= 16

/* Location tab */
export const TAB_CITY		= 30
export const TAB_ASSO		= 31
export const TAB_LOC		= 32

/* Species tab */
export const TAB_LIFER		= 40
export const TAB_TAX_SUMS	= 41

/* Other tab */
export const TAB_OBS_COUNT	= 50
export const TAB_PROGRESS	= 51
export const TAB_TRIP		= 52

/* Missing tab */
export const TAB_CITY_MISSING	= 60
export const TAB_DATE_MISSING	= 61
export const TAB_MONTH_MISSING	= 62
export const TAB_YEAR_MISSING	= 63
